module.exports = __webpack_public_path__ + "img/heel_strike_chart.3c89ae5e.png";